export default __webpack_public_path__ + "static/media/Down-2.7e08f53e.svg";